import { create } from "zustand";

export interface MultiModalControllerState {
  modals: Record<string, boolean>;
  setOpenByModalId: (modalId: string, isOpen: boolean) => void;
}

export const useMultiModalController = create<MultiModalControllerState>()(
  (set) => ({
    modals: {},
    setOpenByModalId: (modalId: string, isOpen: boolean): void => {
      set((state) => ({ modals: { ...state.modals, [modalId]: isOpen } }));
    },
  })
);
